export enum Routes {
  rootUrl = '/',

  // Public
  login = 'login',
  register = 'register',
  joinKrank = 'joinKrank',
  verifyEmail = 'verifyEmail',
  welcomeToKrank = 'welcomeToKrank',

  forgotPassword = 'forgotPassword',
  checkYourEmail = 'checkYourEmail',
  setNewPassword = 'setNewPassword',

  // Private
  configurator = 'configurator',
  settings = 'settings',
  network = 'network',
  role = 'role',
  user = 'user',
  ims = 'ims',
  template = 'template',
  notifications = 'notifications',
  authentication = 'auth',

  home = 'home',
  manage = 'manage',
  dealers = 'dealers',
  manageUsers = 'manageUsers',
  manageListings = 'manageListings',
  businessDivision = 'business-division',
  myTemplate = 'my-template',
  builder = 'builder',
  general = 'general',
  versions = 'versions',
  companyRequest = 'companyRequest',
  tags = 'tags',
  userList = 'list',
  clusters = 'clusters',
  clusterRules = 'cluster-rules',
  networksList = 'list',
  domains = 'domains',
  userProfile = 'profile',
  inventoryList = 'Inventories',
  inventoryAdd = 'add',
  inventoryStatus = 'status',
  inventoryDiscount = 'discount',
  notificationList = 'list',

  //Inspections
  inspections = 'inspections',
  reports = 'reports',
  jobOrders = 'job-orders',
  discrepancyReports = 'discrepancy-reports',

  //coachMode
  coachMode = 'coach-mode',
  magicLink = 'magic-link',
}
